import { Injectable } from '@angular/core';
import { DELIVERY_FEATURE_LAZY, DeliveryZone } from '@delivery/const';
import { facadeFactory } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: DeliveryZonesService,
      feature: DELIVERY_FEATURE_LAZY,
      properties: ['deliveryZones$'],
      methods: ['init'],
      async: true,
    }),
})
export abstract class DeliveryZonesService {
  abstract deliveryZones$: Observable<DeliveryZone[]>;

  abstract init(): void;
}
